import React, { useContext } from "react";
import { ThemeContext } from "../contexts/ThemeContext";
import IconButton from "@mui/material/IconButton";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import Tooltip from "@mui/material/Tooltip";

export default function ThemeToggle() {
  const { mode, toggleMode } = useContext(ThemeContext);

  return (
    <Tooltip title={`Switch to ${mode === "light" ? "dark" : "light"} mode`} arrow>
      <IconButton onClick={toggleMode} aria-label="toggle light/dark mode" color="inherit" size="large">
        {mode === "light" ? <Brightness4Icon /> : <Brightness7Icon />}
      </IconButton>
    </Tooltip>
  );
}